export const weeks = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function getDates(limit=7) {
    const dates = []
    const newDate = new Date().getTime()

    for (let i = 0; i < limit; i++) {
        const nextDay = new Date(newDate + ( i * 24 * 60 * 60 * 1000 ))

        const day =  weeks[nextDay.getDay()]
        const date = `${months[nextDay.getMonth()]} ${nextDay.getDate()}`
        dates.push({day, date, index:i})
        if (dates.length === limit) break
    }

    return dates
}

export const isOpenByTime = (timings) => {
    const today = new Date()
    const currentTime = today.toTimeString().split(' ')[0];
    const currentDay = today.toLocaleDateString('en-US', {weekday:'long'}).toUpperCase()
    let result;
    for (const timing of timings) {
        if (timing?.day==='EVERYDAY'){
            if (currentTime>timing?.openingTime && currentTime<timing?.closingTime){
                return true;
            }else{
                return false;
            }
        }else if (timing?.day===currentDay){
            console.log(timing)
            if (currentTime>timing?.openingTime && currentTime<timing?.closingTime){
                result=true;
            }else{
                result=false;
            }
        }
    }
    return result;
}